import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
  selector: 'mc-preview-mode-watermark',
  templateUrl: './preview-mode-watermark.component.html',
  styleUrls: ['./preview-mode-watermark.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class PreviewModeWatermarkComponent implements OnInit {
  public ngOnInit(): void {}
}
